import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fuzhi",
  "use": "icon-fuzhi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fuzhi\"><defs><style type=\"text/css\"></style></defs><path d=\"M928 96v586.24l-193.536-0.128V928H96V323.392l266.112-0.064V96H928z m-282.56 315.648H185.024v428.16h460.416v-428.16z m193.536-227.392h-387.84v139.072l283.328 0.064v270.464l104.512 0.064V184.32z\" p-id=\"7956\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol